import React from 'react';
import './instagramfeed.css'; // Importing the CSS file for styling

const InstagramFeed = () => {
  const postUrls = [
    "https://www.instagram.com/p/DQrRc7XE_qz/",
    "https://www.instagram.com/p/DMYloRHTyGf/",
    "https://www.instagram.com/p/DLmykxrpIa1/",
    "https://www.instagram.com/p/DKtoMtmJ_RO/",
    'https://www.instagram.com/p/C1XLXMPoEdE/',
    "https://www.instagram.com/p/DJ6KgRdpUC6/",
    'https://www.instagram.com/p/DBLolUTyDif/',
    'https://www.instagram.com/p/C1XLXMPoEdE/', 
    'https://www.instagram.com/p/DBD0cZbJpEM/', 
    'https://www.instagram.com/p/C6I06-RSgVc/',
  ];
  
  return (
    <div className="instagram-galleryi">
      <div className="gallerycenteri">
        <div className="gallery-tracki">
          {postUrls.map((url, index) => (
            <iframe
              key={index}
              src={`https://www.instagram.com/p/${url.split('/p/')[1]}embed`}
              width="250"
              height="340" // Set height equal to width for 1x1 aspect ratio
              frameBorder="0"
              scrolling="no"
              allowTransparency="true"
              className="instagram-posti"
            ></iframe>
          ))}
          {/* Duplicate iframes to create a seamless loop */}
          {postUrls.map((url, index) => (
            <iframe
              key={`${index}-duplicate`}
              src={`https://www.instagram.com/p/${url.split('/p/')[1]}embed`}
              width="250"
              height="340" // Set height equal to width for 1x1 aspect ratio
              frameBorder="0"
              scrolling="no"
              allowTransparency="true"
              className="instagram-posti"
            ></iframe>
          ))}
        </div>
      </div>
    </div>
  );
};

export default InstagramFeed;
